<template>

  <div>

    <ref-tag-list-add-new
      :is-add-new-ref-tag-sidebar-active.sync="isAddNewRefTagSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :tag="refTag"
      @refetch-data="refetchData"
      @add-ref-tag="addRefTag"
      @update-ref-tag="updateRefTag"
      :clear-ref-tag-data="resetRefTagData"
    />

    <!-- Filters -->
    <!-- <ref-tags-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Нэг хуудсанд</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label> бичлэг харуулах</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Хайх..."
              />
              <b-button
                variant="primary"
                @click="isAddNewRefTagSidebarActive = true"
              >
                <span class="text-nowrap">Таг нэмэх</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refRefTagListTable"
        class="position-relative"
        :items="fetchRefTags"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Organization -->
        <template #cell(organization)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveOrganizationRoleVariant(data.item.role)}`"
                :to="{ name: 'organizations-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'organizations-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.organizationname }}</small>
          </b-media>
        </template>

        <!-- Column: is_active -->
        <template #cell(is_active)="data">
          <b-badge
            pill
            :variant="data.item.is_active ? 'success': 'danger'"
          >
            {{ data.item.is_active ? 'идэвхтэй': 'идэвхгүй' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getTag(data.item)" v-b-tooltip.hover.v-primary title="Дэлгэрэнгүй"
              size="sm"
            >
              <feather-icon icon="FileTextIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getTag(data.item)" v-b-tooltip.hover.v-primary title="Засах"
              size="sm"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :variant="data.item.is_active ? 'outline-primary' : 'primary'"
            class="btn-icon __table_action_button"
            @click="confirmDelete(data.item)" v-b-tooltip.hover.v-primary :title="'Устгах'"
            size="sm"
          >
            <feather-icon :icon="'TrashIcon'" />
          </b-button>
        </template>

      </b-table>
      <b-modal id="delete-confirm-modal" @ok="deleteRefTag" ok-title="Тийм"
      cancel-title="Үгүй">
        <template #modal-title>
          Устгахдаа итгэлтэй байна уу?
        </template>
        <p>Та энэ тагыг устгахдаа итгэлтэй байна уу?</p>
      </b-modal>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг  харуулж байна</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import RefTagsListFilters from './RefTagsListFilters.vue'
import useRefTagsList from './useRefTagsList'
import refTagStoreModule from '../refTagStoreModule'
import RefTagListAddNew from './RefTagListAddNew.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    RefTagsListFilters,
    RefTagListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
  setup() {
    const REF_TAG_APP_STORE_MODULE_NAME = 'app-ref-tag'

    // Register module
    if (!store.hasModule(REF_TAG_APP_STORE_MODULE_NAME)) store.registerModule(REF_TAG_APP_STORE_MODULE_NAME, refTagStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REF_TAG_APP_STORE_MODULE_NAME)) store.unregisterModule(REF_TAG_APP_STORE_MODULE_NAME)
    })

    const isAddNewRefTagSidebarActive = ref(false)
    const blankRefTag = {
      name: '',
      priority_point: 0,
      sort_order: '',
    }

    const refTag = ref(JSON.parse(JSON.stringify(blankRefTag)))
    const resetRefTagData = () => {
      refTag.value = JSON.parse(JSON.stringify(blankRefTag))
    }

    const roleOptions = [
      { label: 'Админ', value: 'admin' },
      { label: 'Эрхлэгч', value: 'author' },
      { label: 'Засварлагч', value: 'editor' },
      { label: 'Дэмжигч', value: 'maintainer' },
      { label: 'Дагагч', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Үндсэн', value: 'basic' },
      { label: 'Дэд', value: 'company1' },
      { label: 'Аж ахуй нэгж', value: 'enterprise' },
      { label: 'Баг', value: 'team' },
    ]

    const statusOptions = [
      // { label: 'Хүлээгдэж буй', value: 'pending' },
      { label: 'Идэвхитэй', value: 'true' },
      { label: 'Идэвхигүй', value: 'false' },
    ]

    const addRefTag = val => {
      console.log('val', val)
      store.dispatch('app-ref-tag/addRefTag', val)
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          // fetchRefPriorities()
          refetchData()
        })
    }

    const updateRefTag = val => {
      store.dispatch('app-ref-tag/editRefTag', val)
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          // fetchRefPriorities()
          refetchData()
        })
    }
    
    // const removeRefTag = () => {
    //   store.dispatch('app-todo/removeTask', { id: task.value.id })
    //     .then(() => {
    //       // eslint-disable-next-line no-use-before-define
    //       fetchTasks()
    //     })
    // }

    const getTag = tagData => {
      console.log(tagData)
      refTag.value = tagData
      isAddNewRefTagSidebarActive.value = true
    }


    const {
      fetchRefTags,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRefTagListTable,
      refetchData,
      
      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useRefTagsList()

    

    return {

      // Sidebar
      isAddNewRefTagSidebarActive,

      fetchRefTags,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRefTagListTable,
      refetchData,

      addRefTag,
      updateRefTag,

      // getPriority,
      resetRefTagData,
      refTag,
      getTag,

      // Filter
      avatarText,

      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
  methods: {
    confirmDelete(refTagData) {
      this.refTagData = refTagData;
      this.$bvModal.show('delete-confirm-modal');
    },
    deleteRefTag () {
      if(this.refTagData){
        store.dispatch('app-ref-tag/deleteRefTag', this.refTagData)
        .then(response => {
          console.log(response)
          if (response.data.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: 'BellIcon',
                variant: 'success',
              },
            })
            setTimeout(() => {
              this.$router.go()  // Refresh the current route
            }, 1000) 
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Алдаа гарлаа',
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }
        })
        .finally(() => {
          this.refTagData = null; // Reset the organization after deletion
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.__table_action_button {
  margin-right: 5px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
